/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSharedChartsModule } from '@gh/builder-shared-charts';
import { BuilderDashboardRoutingModule } from './builder-dashboard-routing.module';
import {
  AverageWidgetComponent,
  DashboardComponent,
  DashboardManageDialogComponent,
  DashboardWidgetBodyComponent,
} from './components';
import { DashboardBusinessService } from './resources';

@NgModule({
  imports: [
    MatProgressSpinnerModule,
    BuilderSharedModule.forChild(),
    BuilderSharedChartsModule,
    BuilderDashboardRoutingModule,
  ],
  providers: [
    DashboardBusinessService,
  ],
  declarations: [
    DashboardManageDialogComponent,
    AverageWidgetComponent,
    DashboardComponent,
    DashboardWidgetBodyComponent,
  ],
})
export class BuilderDashboardModule {
}
